// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.record-btn {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.75rem 1rem;
  background-color: #f8f9fa;
  border: 2px solid #ddd;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s;
  font-size: 1rem;
}

.record-btn:hover:not(:disabled) {
  background-color: #e9ecef;
  border-color: #bbb;
}

.record-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.record-btn.recording {
  background-color: #fee;
  border-color: #e74c3c;
  animation: pulse-recording 1.5s ease-in-out infinite;
}

@keyframes pulse-recording {
  0%, 100% {
    box-shadow: 0 0 0 0 rgba(231, 76, 60, 0.4);
  }
  50% {
    box-shadow: 0 0 0 8px rgba(231, 76, 60, 0);
  }
}

.record-icon {
  font-size: 1.25rem;
}

.record-time {
  font-weight: 500;
  color: #e74c3c;
}
`, "",{"version":3,"sources":["webpack://./src/components/AudioRecorder.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,qBAAqB;EACrB,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,qBAAqB;EACrB,oDAAoD;AACtD;;AAEA;EACE;IACE,0CAA0C;EAC5C;EACA;IACE,0CAA0C;EAC5C;AACF;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB","sourcesContent":[".record-btn {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.75rem 1rem;\n  background-color: #f8f9fa;\n  border: 2px solid #ddd;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: all 0.2s;\n  font-size: 1rem;\n}\n\n.record-btn:hover:not(:disabled) {\n  background-color: #e9ecef;\n  border-color: #bbb;\n}\n\n.record-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.record-btn.recording {\n  background-color: #fee;\n  border-color: #e74c3c;\n  animation: pulse-recording 1.5s ease-in-out infinite;\n}\n\n@keyframes pulse-recording {\n  0%, 100% {\n    box-shadow: 0 0 0 0 rgba(231, 76, 60, 0.4);\n  }\n  50% {\n    box-shadow: 0 0 0 8px rgba(231, 76, 60, 0);\n  }\n}\n\n.record-icon {\n  font-size: 1.25rem;\n}\n\n.record-time {\n  font-weight: 500;\n  color: #e74c3c;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
